/**!
 * QCE ATAR Calculator
 * By Daniel15 - 2011-2019
 * Feel free to use any of this, but please link back to my site (dan.cx)
 */

import '../../css/main.css';

import React from 'react';
import ReactDOM from 'react-dom';

import {initAnalytics} from '../analyticsLogger';
import CalculatorQCE from '../components/CalculatorQCE';
import CalculatorContainer from '../containers/CalculatorContainer';
import Data from '../../data/qce.json';
import {State} from '../constants';

ReactDOM.render(
  <CalculatorContainer
    appConfig={{
      ...Data,
      alertMessage: (
        <>
          Unfortunately, QTAC do not provide a mapping from TEA to ATAR, so this calculator uses crowdsourced data from
          prior years and may not be accurate. If you recently graduated and would like to help improve the accuracy,
          please{' '}
          <a 
            href="https://docs.google.com/forms/d/e/1FAIpQLSfqf6pkYsmr4MOZ5NRZd-jYEmZzXISx41zbC-oLrvW7Ik4BBw/viewform?usp=dialog"
            style={{textDecoration: 'underline'}}
            target="_blank">
            let us know your TEA and ATAR anonymously
          </a>. Report any errors by emailing{' '}
          <strong>
            <a href="mailto:%63%61l&#99;%40at%61r%6e%6ftes%2e&#99;om">
              calc@atarnotes.com
            </a>
          </strong>
          .
        </>
      ),
      bugReportMessage: null,
      resourcesURL: 'https://atarnotes.com/free-qce-resources/',
      showSuggestedCourses: true,
      state: State.QCE,
    }}
    calculator={CalculatorQCE}
  />,
  document.getElementById('calculator'),
);

initAnalytics(State.QCE);
